import { connect } from 'react-redux';

import { State } from 'store/types';
import {
  addToDynamicWishlist,
  fetchDynamicWishlist,
} from '@nykaa/prices-revealed-shared/store/action';
import { selectCurrentSku } from 'shared/store/product/selector';
import View from './View';
import { isEligibleForDifferentialPricing } from 'hooks/priceReveal/differentialPrice';

const mapStateToProps = (state: State) => {
  const { priceReveal } = state;
  const {
    childId,
    prData,
    cohortSaleTemplate,
    isEarlyAccess = false,
    isFlashSale = false,
    isPrEnabled = false,
  } = selectCurrentSku(state) || {};
  const saleConfig = {
    isPrEnabled,
    isEarlyAccess,
    isFlashSale,
  };
  const isDifferentialPricingEnabled = isEligibleForDifferentialPricing(state);
  return {
    itemsInDynamicWishlist: priceReveal.items,
    currentSkuId: childId,
    saleConfig,
    prData: isDifferentialPricingEnabled ? cohortSaleTemplate : prData,
    isDifferential: isDifferentialPricingEnabled,
  };
};

const mapDispatchToProps = {
  fetchDynamicWishlist,
  addToDynamicWishlist,
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
